/**
 * Disable/Enable window scroll
 */
const keys = {37: 1, 38: 1, 39: 1, 40: 1};

const preventDefault = (e) => {
    e.preventDefault();
};

const preventDefaultForScrollKeys = (e) => {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
};

// Modern Chrome requires { passive: false } when adding event
let supportsPassive = false;
try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; }
    }));
} catch(e) {}

const wheelOpt = supportsPassive ? { passive: false } : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';



// Check if the event target is inside an element with overflow: scroll
const handleScroll = (e) => {
    const scrollableElement = e.target.closest('[data-scrollable]');
    if (scrollableElement) {
        e.stopPropagation();
    }
};

// Call this to disable scrolling
const disableScroll = () => {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // Older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // Modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // Mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);

    document.addEventListener(wheelEvent, handleScroll, wheelOpt);
};

// Call this to enable scrolling
const enableScroll = () => {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);

    // Remove event listener for checking if the event target is inside a scrollable element
    document.removeEventListener(wheelEvent, handleScroll, wheelOpt);
};

export {disableScroll, enableScroll}